import { Helmet } from "react-helmet";

import {
  Box,
  Container,
  Grid,
  Typography,
  Paper,
  List, ListItemIcon, ListItemText, ListItemButton,
  Icon,
  Chip, Divider, Stack,
} from "@mui/material";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import * as Util from "../../../../services/global.service";
import ReportService from "../../../../services/report.service"

const COLOR_BUTTON = '#5DA196'

const useStyles = makeStyles({
  customAvatarColor: {
    color: "red",
  },
  cardContentHeaderSize: {
    display: "flex",
  },
  cardContentSize: {
    display: "flex",
    justifyContent: "center",
    // flexFlow: "row",
    alignItems: "center",
    height: "calc(100% - 130px)",
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap"
  },
  customCardSize: {
    height: 380,
  },
  titleColor: {
    color: "#B5B5B5"
  },
  subTitleColor: {
    color: "#404349",
    paddingTop: "10px",
    wordBreak: "break-all"
  },
  plusSvg: {
    "& > path": {
      fill: "#fff",
      stroke: "#fff",
    },
  },
  flexPaper: {
    flex: 1,
    minWidth: 350,
    padding: 12,
    // "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
    "border-radius": "10px !important        "
  },
  flexPaperReport: {
    flex: 1,
    minWidth: 350,
    padding: 12,
    marginTop: 10, marginBottom: 10,
    // "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
    "border-radius": "10px !important        "
  },
  root: {
    display: 'flex',
    width: "100%",
    flexWrap: 'wrap'
  }
});
const styles = {
  containerProfile: {
    padding: "22px 25px 40px 24px",
  },
  containerCardContent: {
    paddingTop: "38px"
  },
}

const ReportMain = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState({ id: 'all', name: 'All' });
  const [reports, setReports] = useState([]);

  const onScroll = (evt) => {
    if (evt !== undefined && evt !== null) {
      if (open) {
        setOpen(false)
      }
    }
  }


  useEffect(() => {

    async function fetchData() {

      try {

        const rs = await ReportService.listCategory()
        const category_data = Util.formatData(rs?.data, {})
        let list_category = [{ id: 'all', name: 'All', total_report: category_data.total, icon: 'ad_units' }, ...category_data.categories]
        setCategories(list_category)

        const this_reports = await listReport()
        setReports(this_reports)

      } catch (error) {
        console.error(error)
      }
    }

    fetchData();
  }, [])


  const listReport = async (this_category = null) => {
    try {
      setReports([])

      const rs_reports = await ReportService.listReport(this_category)
      const report_data = Util.formatData(rs_reports?.data, {})

      return report_data.reports

    } catch (error) {
      return []
    }
  }


  const selectCategory = async (cat) => {
    setCategory(cat)
    setReports([])
    const this_reports = await listReport(cat.id)
    setReports(this_reports)
  }

  const selectReport = (report) => {
    let path = '/admin/report/' + report.id
    navigate(path, { replace: false });
  }


  return (

    <Box onScroll={onScroll} style={{ "max-height": "100%", "overflow-y": "auto" }}>
      <Helmet>
        <title>HOME | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth="xl">
          <Grid container item >
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} pt="7px">
              <Typography variant="h2" color="#404349" fontSize={36} lineHeight="40px" >
                {t('admin.label.report.title')}
              </Typography>
            </Box>
          </Grid>


          <Box mt={3} sx={{ display: "flex", width: "100%" }}>
            <Box sx={{ width: "350px" }}>
              <Paper className={classes.flexPaper} >
                <Typography variant="h2" color="#404349" fontSize={24} lineHeight="40px" >
                  {t('admin.label.report.type')}
                </Typography>

                <List>

                  {categories.map((cat, i) => (
                    <>
                      <ListItemButton key={i} selected={(category.id === cat.id)} onClick={() => selectCategory(cat)}>
                        <ListItemIcon>
                          <Icon>{cat.icon}</Icon>
                        </ListItemIcon>
                        <ListItemText primary={cat.name} />
                        <Chip label={cat.total_report} color="success" style={(category.id === cat.id) ? { backgroundColor: COLOR_BUTTON } : { border: '1px solid ' + COLOR_BUTTON }} variant={(category.id === cat.id) ? '' : 'outlined'} />
                      </ListItemButton>
                      <Divider />
                    </>
                  ))}

                </List>
              </Paper>
            </Box>
            <Box sx={{ width: "calc(100% - 350px)" }} pl={3}>
              <Paper className={classes.flexPaper} >
                <Typography variant="h2" color="#5DA196" fontSize={24} lineHeight="40px" >
                  {category.name}
                </Typography>


                <Stack
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="stretch"
                  spacing={1}
                >
                  {reports.map((report, i) => (
                    <ListItemButton key={i} onClick={() => selectReport(report)}>
                      <Paper className={classes.flexPaper}>
                        <ListItemText primary={report.name} />
                      </Paper>
                    </ListItemButton>
                  ))}
                </Stack>

              </Paper>
            </Box>
          </Box>

        </Container>
      </Box>
    </Box>
  )
}


export default ReportMain;
